import { PersonalContentEnvService } from '../env';
import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersonalContentRouting extends BaseRouting {
  static APP_ROUTE = 'personal-content';
  static configPath = ':configId';
  static dashboardSinglePath = 'single/:id';
  static collectionPath = 'collection';
  static collectionSinglePath = 'single/:id';
  static coopPath = 'coop';
  static coopDefaultPath = '';
  static coopJoinPath = 'join/:uniqueId/:entryCode';

  private _collectionSingle: string[] = [
    PersonalContentRouting.collectionPath,
    PersonalContentRouting.collectionSinglePath
  ];
  private _dashboardSingle: string[] = [
    PersonalContentRouting.dashboardPath,
    PersonalContentRouting.dashboardSinglePath
  ];
  private _coopDefault: string[] = [PersonalContentRouting.coopPath];
  private _coopJoin: string[] = [PersonalContentRouting.coopPath, PersonalContentRouting.coopJoinPath];

  constructor(personalContentEnv: PersonalContentEnvService) {
    super(['/' + PersonalContentRouting.APP_ROUTE, PersonalContentRouting.configPath], personalContentEnv);
  }

  public coopDefault(configId = this.getConfigId()): void {
    this.nav(this._coopDefault, {
      configId
    });
  }

  public coopDefaultRouteUrl(configId = this.getConfigId()): string {
    return this.routeUrl(this._coopDefault, {
      configId
    });
  }

  public coopJoinAbsUrl(uniqueId: string, entryCode: string, configId = this.getConfigId()): string {
    return this.absUrl(this._coopJoin, {
      configId,
      uniqueId,
      entryCode
    });
  }

  public dashboardSingle(id: string, configId = this.getConfigId()): void {
    this.nav(this._dashboardSingle, {
      configId,
      id
    });
  }

  public dashboardSingleAbsUrl(id: string, configId = this.getConfigId()): string {
    return this.absUrl(this._dashboardSingle, {
      configId,
      id
    });
  }

  public collectionSingle(id: string, configId = this.getConfigId()): void {
    this.nav(this._collectionSingle, {
      configId,
      id
    });
  }

  public collectionSingleAbsUrl(id: string, configId = this.getConfigId()): string {
    return this.absUrl(this._collectionSingle, {
      configId,
      id
    });
  }

  public collectionSingleRouteUrl(id: string, configId = this.getConfigId()): string {
    return this.routeUrl(this._collectionSingle, {
      configId,
      id
    });
  }
}
